import type { AxiosResponse } from 'axios'
import { getContentDispositionFromHeaders, parseDownloadFilename } from './parseDownloadFilename'

export function downloadAxiosBlobResponse(
  response: AxiosResponse<BlobPart>,
  fallbackName: string,
  mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
) {
  const filename = parseDownloadFilename(
    getContentDispositionFromHeaders(
      response.headers as Record<string, string | string[] | undefined>,
    ),
    fallbackName,
  )
  const blob = new Blob([response.data], { type: mimeType })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
